import styled from 'styled-components';

import Icon from 'components/commons/Icon';

import {
  colorWhite,
  colorPrimary,
  colorAccent,
  colorBlack900,
  colorGray,
  colorGrey75,
  colorGrey200,
  colorGrey400,
  mediaQueryMobileLargeMin,
  colorPrimaryLighten85,
  fontFamilyPrimary,
} from 'styles';

export const SelectLabel = styled.span`
  color: ${colorBlack900};
  margin-left: 11px;
  margin-right: 8px;
  font-size: 14px;
  line-height: 31px;
`;

export const Select = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  align-self: unset;
  margin-top: 0;
  margin-bottom: 15px;
  background: ${colorWhite};
  outline: 0;
  min-width: 156px;
  height: 32px;
  padding: 0 15px;
  border: 1px solid ${colorGrey200};
  box-sizing: border-box;
  border-radius: 2px;
  &:after {
    content: '';
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: 0;
    right: 0;
    z-index: 1;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    align-self: center;
  }

  /* stylelint-disable */
  & > svg {
    /* stylelint-enable */
    display: block;
    fill: ${colorBlack900};
    transform: rotate(0deg);
  }

  &:hover {
    & > svg {
      fill: ${colorBlack900};
    }

    border: 1px solid #87928c;
  }

  ${({ open }) => {
    if (open) {
      return `
        & > svg {
          fill: ${colorBlack900};
          transform: rotate(180deg);
        }

        ${SelectLabel} {
          color: ${colorBlack900};
        }
      `;
    }

    return '';
  }}

  ${({ chart }) =>
    chart &&
    ` 
    min-width: 0;
    width: 50%;
    padding: 8px 0;
    margin: 0;
    &:after {
      top: 0;
      bottom: 0;

    }

    @media all and ${mediaQueryMobileLargeMin} {
      min-width: 95px;
    }
  `}
`;

export const OutlineFieldWrap = styled.div`
  position: relative;
  display: flex;
  align-items: stretch;
  margin: 0;

  &&& {
    margin: 0;
  }
`;

export const OutlineField = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  align-self: unset;
  box-sizing: border-box;
  width: 100%;
  min-width: 190px;
  height: 40px;
  margin: 0;
  padding: 8px 15px;
  background: ${colorWhite};
  border: 1px solid ${colorGrey200};
  border-radius: 2px;
  outline: 0;
  color: ${colorBlack900};
  cursor: pointer;

  &:hover {
    border: 1px solid #87928c;
  }
`;

export const OutlineCalendarIcon = styled(Icon)`
  display: block;
  flex-shrink: 0;
  margin-top: -2px;
  fill: ${colorBlack900};
  pointer-events: none;
`;

export const OutlineFieldLabel = styled.span`
  margin-left: 8px;
  margin-right: 8px;
  font-size: 14px;
  line-height: 24px;
  color: ${colorBlack900};
  white-space: nowrap;
`;

export const OutlineArrowIcon = styled(Icon)`
  display: block;
  margin-left: auto;
  fill: ${colorBlack900};
  pointer-events: none;
`;

export const OutlineDateInput = styled.input`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
  font-size: 16px;

  /* stylelint-disable-next-line */
  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    cursor: pointer;
    opacity: 0;
  }
`;

export const HiddenDateInput = styled.input`
  position: absolute;
  top: -8px;
  right: 0;
  bottom: -8px;
  left: 0;
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  border: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
  font-size: 16px;

  /* stylelint-disable-next-line */
  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    cursor: pointer;
    opacity: 0;
  }
`;

export const InlineContainer = styled.div`
  display: inline-flex;
  position: relative;
  height: 17px;
  align-items: center;
`;

export const InlineText = styled.span`
  color: ${colorAccent};
  margin-right: 8px;
  font-size: 12px;
  line-height: 12px;
  cursor: pointer;
  &:hover {
    color: ${colorPrimary};
  }
`;

export const PickerRoot = styled.div`
  position: relative;
  display: inline-flex;
  align-items: stretch;
  max-width: 100%;

  ${({ $fullWidth }) =>
    $fullWidth &&
    `
    display: flex;
    width: 100%;
  `}
`;

export const CalendarToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 42px;
  padding: 8px 16px;
  background: ${colorGrey75};
`;

export const CalendarToolbarYear = styled.button`
  padding: 0;
  border: 0;
  background: none;
  color: ${({ $active }) => ($active ? colorPrimary : colorGray)};
  font-family: ${fontFamilyPrimary};
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;
`;

export const CalendarToolbarDate = styled.button`
  padding: 0;
  border: 0;
  background: none;
  color: ${({ $active }) => ($active ? colorPrimary : colorGray)};
  font-family: ${fontFamilyPrimary};
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  cursor: pointer;
`;

export const CalendarPopover = styled.div`
  position: fixed;
  z-index: 1300;
  width: 310px;
  overflow: hidden;
  background: ${colorWhite};
  border-radius: 2px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
  font-family: ${fontFamilyPrimary};

  /* stylelint-disable selector-class-pattern, no-descending-specificity */
  .react-calendar {
    width: 100%;
    padding: 8px 8px 12px;
    border: 0;
    background: ${colorWhite};
    font-family: ${fontFamilyPrimary};
    line-height: 16px;
  }

  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    box-sizing: border-box;
  }

  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }

  .react-calendar button:enabled:hover {
    cursor: pointer;
  }

  .react-calendar__navigation {
    display: flex;
    align-items: center;
    height: 36px;
    margin-bottom: 8px;
  }

  .react-calendar__navigation button {
    min-width: 36px;
    color: ${colorBlack900};
    font-size: 14px;
    font-weight: 700;
    background: none;
  }

  .react-calendar__navigation .react-calendar__navigation__arrow {
    height: 36px;
    font-size: 20px;
    line-height: 1;
  }

  .react-calendar__navigation .react-calendar__navigation__arrow:disabled {
    opacity: 0.4;
  }

  .react-calendar__navigation__label {
    pointer-events: none;
    background: ${colorGrey75};
    border-radius: 2px;
  }

  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background: ${colorPrimaryLighten85};
  }

  .react-calendar__month-view__weekdays {
    color: ${colorGrey400};
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    text-transform: lowercase;
  }

  .react-calendar__month-view__weekdays__weekday {
    padding: 8px 0;
  }

  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
  }

  .react-calendar__tile {
    max-width: 100%;
    padding: 4px 0;
    background: none;
    color: ${colorBlack900};
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }

  .react-calendar__tile:disabled {
    background: none;
    color: ${colorGrey200};
  }

  .react-calendar__month-view .react-calendar__tile {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .react-calendar__month-view .react-calendar__tile abbr {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }

  .react-calendar__month-view .react-calendar__tile:enabled:hover abbr,
  .react-calendar__month-view .react-calendar__tile:enabled:focus abbr {
    background: ${colorPrimaryLighten85};
  }

  .react-calendar__month-view .react-calendar__tile--now abbr {
    border: 1px solid ${colorPrimary};
  }

  .react-calendar__month-view .react-calendar__tile--active abbr,
  .react-calendar__month-view .react-calendar__tile--active:enabled:hover abbr,
  .react-calendar__month-view .react-calendar__tile--active:enabled:focus abbr {
    background: ${colorPrimary};
    color: ${colorWhite};
    border-color: ${colorPrimary};
  }

  .react-calendar__decade-view .react-calendar__tile {
    flex-basis: 20% !important;
    max-width: 20%;
    padding: 10px 4px;
    border-radius: 2px;
  }

  .react-calendar__decade-view .react-calendar__tile:enabled:hover,
  .react-calendar__decade-view .react-calendar__tile:enabled:focus {
    background: ${colorPrimaryLighten85};
  }

  .react-calendar__decade-view .react-calendar__tile--hasActive,
  .react-calendar__decade-view .react-calendar__tile--active {
    background: ${colorPrimary};
    color: ${colorWhite};
  }

  /* 4 ряди по 72px + падінги .react-calendar тримають попап квадратним */
  .react-calendar__year-view .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 72px;
    padding: 0 4px;
    text-transform: uppercase;
  }

  .react-calendar__year-view .react-calendar__tile abbr {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 76px;
    height: 36px;
    padding: 0 8px;
    border-radius: 2px;
  }

  .react-calendar__year-view .react-calendar__tile:enabled:hover abbr,
  .react-calendar__year-view .react-calendar__tile:enabled:focus abbr {
    background: ${colorPrimaryLighten85};
  }

  .react-calendar__year-view .react-calendar__tile--hasActive abbr,
  .react-calendar__year-view
    .react-calendar__tile--hasActive:enabled:hover
    abbr,
  .react-calendar__year-view
    .react-calendar__tile--hasActive:enabled:focus
    abbr {
    background: ${colorPrimary};
    color: ${colorWhite};
  }
  /* stylelint-enable selector-class-pattern, no-descending-specificity */
`;
